import { breadcrumb } from './breadcrumb';
import { call } from './call';
import { trunk } from './trunk';
import { stats } from './stats';
import { settings } from './settings';

export const verification = {
  breadcrumb,
  call,
  trunk,
  stats,
  settings
};
